import React from 'react';
import { Table } from 'semantic-ui-react';
import { map, range } from 'ramda';
import TableHeader from './Header.js';
import TableRow from './Row.js';
import { generate } from 'shortid';


const AwsJsonTable = (props) =>  {
  const { data, cols, rowCount = 0 } = props;

  return (
    <Table celled className="rtxJsonTable">
      <TableHeader cols={cols} />
      <Table.Body>
        { map(ix =>
              <TableRow
                key={generate()}
                rowNum={ix}
                cols={cols}
                data={data[ix]}
                onChange={props.onChange}
              />,
              range(0, rowCount)) }
      </Table.Body>
    </Table>
  );
};

export default AwsJsonTable;



// WEBPACK FOOTER //
// ./src/private/common/components/AwsJsonTable/index.js